import {helpers} from "../helpers";
import {GLICEMIC_INDEX, GLICEMIC_LOAD} from "../services/NutrientDetailsProvider";

export default {
  configuration: (state) => {
    return state.configuration;
  },
  countries: (state) => {
    return state.countries;
  },
  countryName:(state) => (code) => {
    const country = state.countries.find((country) => {
      return country.code === code;
    });
    if (country === undefined) {
      return '';
    }
    return country.name;
  },
  MENU_ID: (state) => state.menu.id,
  MENU_MODE: (state) => state.configuration && state.configuration.mode === 'menu',
  SYSTEM_SCHEMA: (state) => state.configuration && state.configuration.system,
  MENU_DAYS_IDS: (state) => state.menu.schema.days.map(d => d.id),
  MENU_DAYS_LENGTH: (state) => state.menu.schema.days.length,
  USER: (state) => state.user,
  hasPermission: (state, getters) => (permission) => {
    if (state.user.permissions.length === 0) {
      return false;
    }

    const passthrough = ['menu_schema_import'];

    if (!passthrough.includes(permission) && getters.MENU_ID && getters.MENU_READ_ONLY) {
      return state.user.permissions.includes('schema_system_create');
    }

    return state.user.permissions.includes(permission);
  },
  maxMenuDaysLength: (state) => state.user.max_menu_days_length,
  canUseSharing: (state) => state.user.can_use_sharing,
  userRole: (state) => state.user.role,
  isUserActive: (state) => {
    return state.user.is_active;
  },
  somePermission: (state, getters) => (...permissions) => permissions.map(p => getters.hasPermission(p)).filter(p => p === true).length > 0,
  MENU_READ_ONLY: (state) => state.configuration && state.configuration.readonly,
  MENU_PRESCRIBED_NUTRIENTS: (state) => {
    if (state.menu.schema) {
      return state.menu.schema.prescribedNutrients;
    }
    return {};
  },
  getNutrientsByDay: (state) => (id) => {
    const plans = state.menu.schema.days
      .find(day => day.id === id)
      .plans;

    const total = {};

    const prescribedNutrients = helpers.deepClone(state.menu.schema.prescribedNutrients);

    for (const externalId in prescribedNutrients) {
      if (!total[externalId]) {
        total[externalId] = 0;
      }
      total[externalId] = plans.map(p => p.sumNutrientById(externalId)).reduce((s, t) => s + t, 0);
    }

    total[GLICEMIC_INDEX] = plans.map(p => p.calculateGlicemicIndex()).reduce((s, t) => s + t, 0);
    total[GLICEMIC_LOAD] = plans.map(p => p.calculateGlicemicLoad()).reduce((s, t) => s + t, 0);

    return total;
  },
  getDayById: (state) => (id) => {
    return state.menu.schema.days.find(day => day.id === id);
  },
  getDayIndexById: (state) => (id) => {
    return state.menu.schema.days.findIndex(day => day.id === id);
  },
  getPlanById: (state) => (dayId, planId) => {
    return state.menu.schema.days.find(day => day.id === dayId).getPlan(planId);
  },
  commentsHidden: (state) => state.commentsHidden,
  productReplacements: (state) => state.productReplacements,
  foodsWithReplacements: (state) => state.foodsWithReplacements,
  productsReplaced: (state) => state.productsReplaced,
  foodsWithSearchedProduct: (state) => state.foodsWithSearchedProduct,
  productsSameAsSearchedProduct: (state) => state.productsSameAsSearchedProduct,
  dragAndCopyEnabled: (state) => state.dragAndCopyEnabled,
  sentToMobileAppAt: (state) => state.sentToMobileAppAt,
};
